var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-banner"},[_c('p',[_vm._v(" Hire a Bartender Who Knows The Best Cocktail Drinks! "),_c('a',{attrs:{"href":"https://bartendlongisland.com/bartender-booking/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Book a Bartender Now ")])])])
}]

export { render, staticRenderFns }